import React, { FC, useState, CSSProperties } from 'react'
import ReactResizeDetector from 'react-resize-detector'
import styled, { CSSProp } from 'styled-components'
import AceEditor from 'react-ace'
import { Ace } from 'ace-builds'

export type EditorMode = 'css' | 'xml' | 'javascript' | 'json' | 'markdown'

type Props = {
  value: string
  isReadOnly?: boolean
  isWrapTextEnabled?: boolean
  onChange: (value: string) => void
  mode?: EditorMode
  focus?: boolean
  initialRowsCount?: number
  placeholder?: string
  onFocus?: () => void
  onBlur?: () => void
  wrapperCss?: CSSProperties | CSSProp
  resizeCssRule?: 'none' | 'both' | 'horizontal' | 'vertical' | 'block' | 'inline'
}

export const FeedbotAce: FC<Props> = ({
  mode,
  value,
  resizeCssRule,
  initialRowsCount,
  focus,
  wrapperCss,
  isReadOnly,
  placeholder,
  isWrapTextEnabled,
  onFocus,
  onBlur,
  onChange
}) => {
  const [editorWidth, setEditorWidth] = useState<number>()
  const [editorHeight, setEditorHeight] = useState<number>()

  return (
    <Wrapper $resize={resizeCssRule} $initialRowsCount={initialRowsCount} css={wrapperCss}>
      <ReactResizeDetector
        handleWidth
        handleHeight
        onResize={(width, height) => {
          setEditorWidth(width)
          setEditorHeight(height)
        }}
      />
      <StyledAceEditor
        mode={mode}
        tabSize={2}
        value={value}
        focus={focus}
        theme="tomorrow"
        defaultValue={value}
        readOnly={isReadOnly}
        wrapEnabled={isWrapTextEnabled}
        width={editorWidth?.toString()}
        height={editorHeight?.toString()}
        setOptions={{ useSoftTabs: false }}
        placeholder={placeholder}
        editorProps={{ $blockScrolling: Infinity }}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
      />
    </Wrapper>
  )
}

export type FeedbotAceProps = Props

const StyledAceEditor = styled(AceEditor)`
  width: 100% !important;
  height: 100% !important;
`

const Wrapper = styled.div<{ $resize?: string; $initialRowsCount?: number }>`
  overflow: auto;
  scroll-behavior: smooth;

  resize: vertical;
  resize ${({ $resize }) => ($resize ? $resize : 'vertical')};

  height: 100px;
  height: ${({ $initialRowsCount }) => ($initialRowsCount || 10) * 12.1}px;

  flex: 1;
  border-radius: 4px;
  border: 1px solid #ccc;
  
  & + div:not(:empty) {
    // Targeting validation error element - nothing more to go by :/
    width: 100%;
    text-align: right;
    white-space: break-spaces;
  }
`
